// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SelectList__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SelectList/SelectList.scss
 ** module id = 382
 ** module chunks = 1
 **/